import e from "../../utils/classNames.js";
import t from "../collapse/Collapse.js";
import { hasBorderClass as n, hasRoundedClass as r } from "../../utils/hasUtilityClass.js";
import { useState as i } from "react";
import { isEqual as a } from "es-toolkit/predicate";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
//#region src/components/expander/ExpanderList.tsx
var c = () => (Math.random() + 1).toString(36).toUpperCase().substring(2), l = (e) => e.map((e) => (e.id ||= c(), e)), u = (c) => {
	let { items: u = [], unmountOnExit: p = !0, rounded: m = !0, bordered: h = !0, className: g = "" } = c, [_, v] = i(l(u)), [y, b] = i(u);
	a(y, u) || (v(l(u)), b(u));
	let x = (e) => {
		if (!e.body) return;
		let t = [..._].map((t) => (t.id === e.id && (t.onOpen && !t.open && t.onOpen(), t.onClose && t.open && t.onClose(), t.open = !t.open), t));
		v(t);
	}, S = e("expander-list list-group", m && !r(g) && "rounded", h && !n(g) && "border", g);
	return /* @__PURE__ */ o("ul", {
		className: S,
		children: _.map((n) => {
			let r = n.open, i = e("list-group-item", n.className && n.className, n.body ? "expandable" : "", r && "open");
			return /* @__PURE__ */ s("li", {
				className: i,
				children: [/* @__PURE__ */ o(d, {
					item: n,
					onToggle: x
				}), n.body && /* @__PURE__ */ o(t, {
					open: r,
					unmountOnExit: p,
					children: /* @__PURE__ */ o("div", {
						className: "expander-list-body-wrapper",
						children: /* @__PURE__ */ o(f, {
							className: n.bodyClassName,
							children: n.body
						})
					})
				})]
			}, n.id);
		})
	});
}, d = ({ item: t, onToggle: n }) => {
	let r = e("expander-list-header", t.headerClassName), i = e("expander-icon", "uikit-icon", "icon-chevron-down");
	return /* @__PURE__ */ s("div", {
		className: r,
		onClick: () => n(t),
		"aria-label": "expander item header",
		...t.trackingAttributes,
		children: [/* @__PURE__ */ o("span", {
			className: "expander-list-header-content",
			children: t.header
		}), t.body && /* @__PURE__ */ o("span", { className: i })]
	});
}, f = ({ className: t, children: n }) => {
	let r = e("expander-list-body", t);
	return /* @__PURE__ */ o("div", {
		className: r,
		"aria-label": "expander item body",
		children: n
	});
};
//#endregion
export { u as default };

//# sourceMappingURL=ExpanderList.js.map